import { ENTITY_LABEL } from "../../../Helpers/Labels/EntityLabel";

export const NO_ENTITY_AVAILABLE_OPTION = {
    name: `No ${ENTITY_LABEL} available`,
    id: "no-entity-available"
};

export const NO_PAGE_AVAILABLE_OPTION = {
    pageName: "No page available",
    _id: "no-page-available"
};